import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
    title,
    description,
    lang = 'en',
    meta = [],
    image,
    type = 'website',
    url,
    alternateUrls = [],
    structuredData = null
}) => {
    const metaDescription = description || 'Drockerhof - Relax in the middle of nature'
    const defaultTitle = 'Drockerhof'
    const siteUrl = url || 'https://www.drockerhof.it'
    const defaultImage = image || '/android-chrome-192x192.png'

    return (
        <Helmet
            htmlAttributes={{
                lang,
            }}
            title={title}
            titleTemplate={`%s | ${defaultTitle}`}
            defaultTitle={defaultTitle}
            meta={[
                {
                    name: 'description',
                    content: metaDescription,
                },
                {
                    property: 'og:title',
                    content: title || defaultTitle,
                },
                {
                    property: 'og:description',
                    content: metaDescription,
                },
                {
                    property: 'og:type',
                    content: type,
                },
                {
                    property: 'og:url',
                    content: siteUrl,
                },
                {
                    property: 'og:image',
                    content: defaultImage,
                },
                {
                    property: 'og:locale',
                    content: lang,
                },
                {
                    name: 'twitter:card',
                    content: 'summary_large_image',
                },
                {
                    name: 'twitter:title',
                    content: title || defaultTitle,
                },
                {
                    name: 'twitter:description',
                    content: metaDescription,
                },
                {
                    name: 'twitter:image',
                    content: defaultImage,
                },
            ].concat(meta)}
        >
            {/* Language alternates */}
            {alternateUrls.map(({ lang, url }) => (
                <link rel="alternate" key={lang} hrefLang={lang} href={url} />
            ))}

            {/* Structured Data */}
            {structuredData && (
                <script type="application/ld+json">
                    {JSON.stringify(structuredData)}
                </script>
            )}
        </Helmet>
    )
}

export default SEO
